// import axios from 'react-axios';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://www.tyclinternational.org/art-camp/service/'
});

const postApiCall = (url, data) => {
  return axiosInstance.post(url, data)
    .then(response => response)
    .catch(err => {
      throw err;
    });
}

const getApiCall = (url, data) => {
  return axiosInstance.get(url, data)
    .then(response => response)
    .catch(error => {
      console.error('There was an error!', error);
    });
}

const putApiCall = (url, data) => {
  return axiosInstance.put(url, data)
    .then(response => response)
    .catch(error => {
      console.error('There was an error!', error);
    });
}


export { getApiCall, putApiCall, postApiCall };